import { useState, useEffect } from "react";
import { Compass, RefreshCw, ChevronRight } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function TopPicksByTabCompact({ owner, onTabChange, onAnalyze }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    if (!owner) return;
    setLoading(true);
    try {
      const r = await axios.get(`${API}/api/briefing/top-picks-by-tab/${owner}`, { timeout: 15000 });
      setData(r.data);
    } catch (e) {
      console.error("Top picks compact error", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, [owner]);  // eslint-disable-line

  return (
    <div className="glass-card rounded-xl p-3 flex flex-col" data-testid="top-picks-by-tab-compact">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1.5">
          <Compass className="w-3.5 h-3.5 text-amber-400" />
          <span className="text-xs font-bold text-white">Top par Onglet</span>
          {data?.total > 0 && (
            <span className="text-[9px] font-mono text-slate-500">·{data.total}</span>
          )}
        </div>
        <button onClick={fetchData} disabled={loading}
          className="text-slate-500 hover:text-amber-400 transition-colors p-0.5 disabled:opacity-40"
          data-testid="top-picks-compact-refresh">
          <RefreshCw className={`w-3 h-3 ${loading ? "animate-spin" : ""}`} />
        </button>
      </div>

      {loading && !data ? (
        <div className="text-[10px] text-slate-500 text-center py-4">Agrégation des opportunités...</div>
      ) : !data?.picks?.length ? (
        <div className="text-[10px] text-slate-500 text-center py-4">Aucune opportunité détectée</div>
      ) : (
        <div className="space-y-0.5 overflow-y-auto custom-scrollbar max-h-[260px] pr-0.5">
          {data.picks.map((p, i) => (
            <button
              key={i}
              onClick={() => {
                if (onTabChange && p.tab_route) onTabChange(p.tab_route);
                if (onAnalyze && p.ticker) onAnalyze(p.ticker);
              }}
              className="w-full flex items-center gap-1.5 px-1.5 py-1 rounded hover:bg-slate-700/40 border border-transparent hover:border-amber-500/30 transition-all group text-left"
              data-testid={`top-pick-compact-${p.tab_route}`}
            >
              <span className="text-[8px] font-bold text-amber-400/80 uppercase tracking-tight w-14 shrink-0 truncate">
                {p.tab.replace("Pepites › ", "P›").replace("Earnings/", "")}
              </span>
              <span className="text-[10px] font-mono font-bold text-white w-12 shrink-0 truncate">
                {p.ticker}
              </span>
              <span className="text-[9px] text-slate-300 flex-1 truncate" title={p.reason}>
                {p.headline.replace(`${p.ticker} — `, "")}
              </span>
              <ChevronRight className="w-2.5 h-2.5 text-slate-600 group-hover:text-amber-400 shrink-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
